module.exports = __webpack_public_path__ + "static/img/LA.b6f941d1.png";